import type { Project } from "../types";
import { ProjectEdit } from "./ProjectEdit";
import { ProjectList } from "./ProjectList";

/**
 * ASSUMPTIONS (Almikia Epic E1 backlog):
 * - No create page: project codes are constrained to the 6 known values
 *   already seeded in the database (TASK-001).
 * - No delete action: catalogue records are never hard-deleted, enforced
 *   both in the UI (canAccess.ts) and at the database level (TASK-001).
 */
export default {
  list: ProjectList,
  edit: ProjectEdit,
  recordRepresentation: (record: Project) => `${record.name} (${record.code})`,
};
